// extracted by mini-css-extract-plugin
module.exports = {"icon":"tip_icon_3aIct","title":"tip_title_MLaza"};